export default {
  "accountReceivable.accountReceivable": "売掛金",
  "accountReceivable.accountReceivableRegistration": "売掛金登録",
  "accountReceivable.consolidatedInvoiceIssuance": "一括請求書発行",
  "accountReceivable.bulkDepositRegistration": "一括入金登録",
  "accountReceivable.depositRegistration": "入金登録",
  "accountReceivable.invoiceIssuance": "請求書発行",
  "accountReceivable.client": "取引先",
  "accountReceivable.requestName": "請求件名",
  "accountReceivable.accountReceivableEdit": "売掛金編集",
  "accountReceivable.invoiceNumber": "請求書番号",
  "accountReceivable.cinemas": "対象劇場（複数選択可）",
  "accountReceivable.clientTarget": "対象取引先",
  "accountReceivable.salesDate": "売上計上日",
  "accountReceivable.billingDeadline": "請求締日",
  "accountReceivable.paymentDeadline": "入金期限",
  "accountReceivable.plannedDepositDate": "入金予定日",
  "accountReceivable.billingAmount": "請求金額",
  "accountReceivable.depositedAmount": "入金済額",
  "accountReceivable.accountsReceivableBalance": "売掛金残高",
  "accountReceivable.issued": "発行済",
  "accountReceivable.unissued": "未発行",
  "accountReceivable.invoice": "請求書",
  "accountReceivable.trTotal": "全集計明細合計額",
  "accountReceivable.checkTrTotal": "選択明細の合計額",
  "accountReceivable.invoiceInfo": "請求書情報",
  "accountReceivable.totalBillingAmount": "請求合計金額",
  "accountReceivable.payee": "振込先",
  "accountReceivable.appreciationInfo": "請求明細（鑑賞券）",
  "accountReceivable.appreciationExtractionPeriod": "売掛金（鑑賞券）抽出対象期間",
  "accountReceivable.concessionExtractionPeriod": "売掛金（コンセッション / 物販）抽出対象期間",
  "accountReceivable.otherRevenueExtractionPeriod": "売掛金（その他営業収入）抽出対象期間",
  "accountReceivable.extract": "抽出",
  "accountReceivable.complimentaryTicketName": "優待券名",
  "accountReceivable.clientInfo": "取引先情報（請求書記載用）",
  "accountReceivable.clientName": "取引先名",
  "accountReceivable.departmentCharge": "担当部署",
  "accountReceivable.personinCharge": "担当者役職",
  "accountReceivable.personName": "担当者氏名",
  "accountReceivable.honorificTitle": "敬称",
  "accountReceivable.postalCode": "郵便番号",
  "accountReceivable.area": "エリア",
  "accountReceivable.prefectures": "都道府県",
  "accountReceivable.city": "市区町村",
  "accountReceivable.address1": "住所1（市区町村以下〜番地）",
  "accountReceivable.address2": "住所2（建物名〜号室）",
  "accountReceivable.phone": "電話番号",
  "accountReceivable.faxCode": "FAX番号",
  "accountReceivable.responsibleperson": "自社担当者",
  "accountReceivable.salesCommission": "販売手数料",
  "accountReceivable.concessionCommercial": "請求明細（コンセッション / 物販）",
  "accountReceivable.goodName": "商品名",
  "accountReceivable.purchaseInfo": "請求明細（仕入相殺等）",
  "accountReceivable.arithmetic": "加減算",
  "accountReceivable.plus": "相殺(加算)",
  "accountReceivable.reduce": "相殺(減算)",
  "accountReceivable.plus1": "加算",
  "accountReceivable.reduce1": "減算",
  "accountReceivable.itemName": "品目名",
  "accountReceivable.totalAmount": "合計額",
  "accountReceivable.accountPayableModule": "請求明細（買掛金相殺）",
  "accountReceivable.accountsPayableBalance": "買掛金残高",
  "accountReceivable.offsetAmount": "相殺金額",
  "accountReceivable.afterOffset": "相殺後買掛金残高",
  "accountReceivable.otherRevenueInfo": "請求明細（その他営業収入）",
  "accountReceivable.paymentDetail": "入金明細",
  "accountReceivable.accountReceivableDetail": "売掛金明細",
  "accountReceivable.paymentDetailName": "入金明細名",
  "accountReceivable.depositDate": "入金日",
  "accountReceivable.depositClassification": "売掛金入金区分",
  "accountReceivable.accountPayment": "口座支払",
  "accountReceivable.fromDepositDestination": "預金先から選択",
  "accountReceivable.offset": "相殺",
  "accountReceivable.fromAccountReceivableStatement": "買掛金明細から選択",
  "accountReceivable.offsetPaymentStatement": "選択した買掛金明細に「相殺による支払明細」を作成する",
  "accountReceivable.cash": "現金支払",
  "accountReceivable.autoCash": "現金",
  "accountReceivable.inputTotalDepositAmount": "入金合計金額",
  "accountReceivable.copyPayable": "入金金額に売掛金残高の金額をコピー",
  "accountReceivable.otherOffset": "その他相殺",
  "accountReceivable.depositAmount": "入金金額",
  "accountReceivable.salesAdjustment": "売上調整",
  "accountReceivable.totalDepositAmount": "入金金額合計額",
  "accountReceivable.totalAccountsReceivable": "売掛金残高合計",
  "accountReceivable.differenceTotal": "入金合計金額との差額",
  "accountReceivable.threeTotal": "入金/調整/相殺金額",
  "accountReceivable.you": "御中",
  "accountReceivable.taxRate1": "10%対象",
  "accountReceivable.taxRate2": "-10%対象",
  "accountReceivable.taxRate3": "8%対象",
  "accountReceivable.taxRate4": "-8%対象",
  "accountReceivable.taxRate5": "対象外",
  "accountReceivable.breakdownOfConsumptionTax": "消費税内訳",
  "accountReceivable.internalConsumptionTax": "内消費税",
  "accountReceivable.batchRegistration": "一括入金（売掛金）登録",
  "accountReceivable.targetPeriod": "対象期間",
  "accountReceivable.bulkDeposit": "一括入金",
  "accountReceivable.billingStatement": "請求明細",
  "accountReceivable.accountsPayableOffset": "買掛金相殺",
  "accountReceivable.otherPurchaseOffset": "その他仕入相殺",
  "accountReceivable.otherOperatingIncomeOffset": "その他営業収入相殺",
  "accountReceivable.otherOffsetTotal": "その他相殺合計",
  "accountReceivable.nationwideCommonTicketTotal": "全国共通券集計",
  "accountReceivable.settlementSummary": "決済集計",
  "accountReceivable.showCompanySeal": "会社印を表示",
  "accountReceivable.showManagerSeal": "支配人印を表示",
  "accountReceivable.showHeadSeal": "担当印を表示",
  "accountReceivable.billMonth": "账单月",
  "accountReceivable.nationalDetail": "請求明細（全国共通券 / 着券）",
  "accountReceivable.nationalSalesDetail": "請求明細（全国共通券 / 販売）",
  "accountReceivable.extractionTime": "抽出対象期間",
  "accountReceivable.nationalTicketName": "全国共通券名",
  "accountReceivable.income": "興行収入",
  "accountReceivable.price": "販売金額",
  "accountReceivable.salesCommission1": "手数料売上",
  "accountReceivable.paymentType": "売掛金支払区分",

  "accountReceivable.placeholder.select": "選択してください",
  "accountReceivable.placeholder.requestName": "請求件名を入力してください",
  "accountReceivable.placeholder.invoiceNumber": "請求書番号を入力してください",
  "accountReceivable.placeholder.cinemas": "対象劇場を選択してください",
  "accountReceivable.placeholder.clientTarget": "取引先を選択してください",
  "accountReceivable.placeholder.payee": "預金先を選択してください",
  "accountReceivable.placeholder.comment": "備考/摘要を入力してください",
  "accountReceivable.placeholder.clientName": "取引先名を入力してください",
  "accountReceivable.placeholder.departmentCharge": "例) 営業部",
  "accountReceivable.placeholder.personinCharge": "例) 課長",
  "accountReceivable.placeholder.personName": "例) 映画　太郎",
  "accountReceivable.placeholder.honorificTitle": "例) 御中／様",
  "accountReceivable.placeholder.postalCode": "例) 123-4567",
  "accountReceivable.placeholder.area": "エリアを検索してください",
  "accountReceivable.placeholder.prefectures": "例) 東京都",
  "accountReceivable.placeholder.city": "例) 中央区",
  "accountReceivable.placeholder.address1": "例) 日本橋〇-〇-〇",
  "accountReceivable.placeholder.address2": "例) 〇〇ビル　〇〇〇号室",
  "accountReceivable.placeholder.phone": "例) 030-0000-0000",
  "accountReceivable.placeholder.faxCode": "例) 030-0000-0000",
  "accountReceivable.placeholder.email": "例) eigataro@eigaland.com",
  "accountReceivable.placeholder.responsibleperson": "例) 映画　花子",
  "accountReceivable.placeholder.input": "入力してください",
  "accountReceivable.placeholder.paymentDetailName": "入金明細名を入力してください",
  "accountReceivable.placeholder.totalDepositAmount": "支払合計金額を入力してください",

  "accountReceivable.creditReceivable": "決済集計",
  "accountReceivable.creditReceivableRegistration": "売掛金（決済集計)",
  "accountReceivable.nationTicket": "全国共通券集計",
  "accountReceivable.creditModule": "請求明細（決済）",
  "accountReceivable.creditExtractPeriod": "売掛金（決済）抽出対象期間",
  "accountReceivable.creditPaymentName": "決済名",
  "accountReceivable.creditPaymentDate": "決済日",
  "accountReceivable.creditFees": "決済手数料",

  "accountReceivable.requireField": "記入する必要があります",
  "accountReceivable.requireSelect": "選択する必要があります",
  "accountReceivable.requireAuto": "選択後に自動的に入力",
  "accountReceivable.require.fileName": "請求件名を入力してください",
  "accountReceivable.require.bookName": "請求書番号を入力してください",
  "accountReceivable.require.cinema": "対象劇場を入力してください",
  "accountReceivable.require.client": "対象取引先を選択してください",
  "accountReceivable.require.balanceDate": "売上計上日を選択してください",
  "accountReceivable.require.collectDate": "請求締日を選択してください",

  "accountReceivable.error.cinemaIds": "対象劇場の選択は空です",
  "accountReceivable.error.clientId": "対象取引先の選択は空です",
  "accountReceivable.warn.zerodata": "データがありません",
  "accountReceivable.error.invalidOptionType": "accountReceivable.error.invalidOptionType",
  "accountReceivable.error.bankNotFound": "振込先存在しません",
};